import {Pipe, PipeTransform} from '@angular/core';
import {ChangeRequestVO} from '../generate/TldChangeResultVO';

@Pipe({
    name: 'workflowMappingHelper',
    standalone: false
})
export class WorkflowMappingHelperPipe implements PipeTransform {

  workflowMapping = new Map();

  constructor() {
    this.workflowMapping.set('INITIAL_REVIEW', 'Initial Review');
    this.workflowMapping.set('TECHNICAL_CHECKS', 'Technical Checks');
    this.workflowMapping.set('CONTACT_CONFIRMATION', 'Contact Confirmation');
    this.workflowMapping.set('STAFF_REVIEW', 'Staff Review');
    this.workflowMapping.set('BOARD_REVIEW', 'ICANN Board Review');
    this.workflowMapping.set('REGULATORY_CHECKS', 'Regulatory Checks');
    this.workflowMapping.set('SUPP_TECHNICAL_CHECKS', 'Supplemental Technical Checks');
    this.workflowMapping.set('ROOT_ZONE_MAINTAINER_UPDATE', 'Root Zone Maintainer Update');
    this.workflowMapping.set('ADMIN_CLOSED', 'Admin Closed');
    this.workflowMapping.set('WITHDRAWN', 'Withdrawn');
    this.workflowMapping.set('COMPLETED', 'Completed');
    this.workflowMapping.set('REJECTED', 'Rejected');
    this.workflowMapping.set('POST_PROCESSING', 'Post Processing');
    this.workflowMapping.set('CLOSED', 'Completed');
  }

  transform(value: any,  changeRequestVO?: ChangeRequestVO): any {
        return this.workflowMapping.has(value) ? this.workflowMapping.get(value) : value;
  }

}
